import React from 'react'

/**
 * Single-layer site background: 88px grid (radial-masked).
 * The noise overlay was removed at user request — too dark.
 */
export default function BackgroundFx() {
    return <div className="bg-grid" aria-hidden="true" />
}
